<template>
    <span v-if="mostrarBtnDetalheAprovacaoJustificada">
        <span class="text-primary ml-1">
            <i
                class="fa fa-info-circle fa-lg icon-button"
                title="Detalhe da Aprovação Justificada"
                @click.stop="mostrarDetalheAprovacaoJustificada()"
            ></i>
        </span>
        <b-modal
            id="modalDetalheReprovacao"
            v-model="mostrarModalDetalheAprovacaoJustificada"
        >
            <div slot="modal-title">
                Registro de Pagamento - Detalhe da aprovação
            </div>
            <b-row>
                <b-col sm="12" v-if="pagamento.categoriaAprovacaoJustificada != null">
                    <b-form-group>
                        <label>
                            Categoria da aprovação
                        </label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                v-model="pagamento.categoriaAprovacaoJustificada"
                                :disabled="true"
                            ></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" v-if="pagamento.detalheAprovacaoJustificada != null">
                    <b-form-group>
                        <label for="contato">Detalhe</label>
                        <b-form-textarea
                            v-model="pagamento.detalheAprovacaoJustificada"
                            :rows="4"
                            :disabled="true"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharDetalheAprovacaoJustificada()"
                    >Fechar</b-button
                >
            </div>
        </b-modal>
    </span>
</template>

<script>
import { pagamentoStatus } from './PagamentoStatus'

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModalDetalheAprovacaoJustificada: false
        }
    },

    methods: {
        mostrarDetalheAprovacaoJustificada() {
            this.mostrarModalDetalheAprovacaoJustificada = true
        },

        fecharDetalheAprovacaoJustificada() {
            this.mostrarModalDetalheAprovacaoJustificada = false
        }
    },

    computed: {
        mostrarBtnDetalheAprovacaoJustificada() {
            return (
                this.pagamento.status === pagamentoStatus.AGUARDANDO_SETOR_FINANCEIRO ||
                (this.pagamento.status ===
                    pagamentoStatus.EM_PROCESSAMENTO_PELO_SETOR_FINANCEIRO)
            )
        },
    }
}
</script>
